import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "../../styles/Bottomsection.css";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";

function Bottomhero({ botbanner, obj }) {
  const { language } = useContext(LanguageContext);
  return (
    <div className="bottomhero">
      <div className="et_pb_section et_pb_section_3 et_pb_section_parallax et_pb_with_background et_section_regular section_has_divider et_pb_bottom_divider et_pb_top_divider">
        <div className="et_pb_top_inside_divider et-no-transition"></div>
        <div className="et_parallax_bg_wrap">
          <div
            className="et_parallax_bg"
            style={{
              backgroundImage: botbanner
                ? `url(${botbanner})`
                : `url(${obj.image})`,
            }}
          ></div>
        </div>
        <div className="container">
          <div
            className="row"
            style={{ marginLeft: "auto" }}
            //  className="et_pb_row et_pb_row_3 et_pb_row_fullwidth"
          >
            <div
              className="col-12"
              //  className="et_pb_column et_pb_column_4_4 et_pb_column_5  et_pb_css_mix_blend_mode_passthrough et-last-child"
            >
              <div className="et_pb_module et_pb_text et_pb_text_5  et_pb_text_align_center et_pb_bg_layout_dark">
                <div className="et_pb_text_inner">
                  <h3>{TEXT[language]["BOTTOMHERO"]["0"]}</h3>
                  <h2>{TEXT[language]["BOTTOMHERO"]["1"]}</h2>
                </div>
              </div>{" "}
            </div>
            <div className="sustainathon_button_module_wrapper">
              <Link
                className="main_button  sustainathon_anim_button  sustainathon_button_padding"
                role="button"
                style={{ textDecoration: "none", textAlign: "center" }}
                to="/events"
              >
                <span>{TEXT[language]["BOTTOMHERO"]["2"]}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Bottomhero;
